import { render, staticRenderFns } from "./CardCollapse.vue?vue&type=template&id=58a7ca38&scoped=true&"
import script from "./CardCollapse.vue?vue&type=script&lang=ts&"
export * from "./CardCollapse.vue?vue&type=script&lang=ts&"
import style0 from "./CardCollapse.vue?vue&type=style&index=0&id=58a7ca38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a7ca38",
  null
  
)

export default component.exports